export const orderTypes = {
  SET_FILTERS_PARAMS: "SET_FILTERS_PARAMS",
  GET_ORDERS: "GET_ORDERS",
  SELECT_ORDER: "SELECT_ORDER",
  FILTER_ORDERS: "FILTER_ORDERS",
  SET_ORDER_SCHEDULE: "SET_ORDER_SCHEDULE",
  SET_ORDER_CAUSES: "SET_ORDER_CAUSES",
  EDIT_ORDER: "EDIT_ORDER",
  ADD_COMMENT: "ADD_COMMENT",
  SET_COUPON_ORDER: "SET_COUPON_ORDER",
  RESTORE_INITIAL: "RESTORE_INITIAL",
  GET_SERVICE_DETAILS: "GET_SERVICE_DETAILS",
  SET_NEW_PAYMENT_LINK: "SET_NEW_PAYMENT_LINK",
  ADD_ETA: "ADD_ETA"
}